/*
  LA Q4 kampanyası (9 Eki 2026) - bar, slayt ve ürün şeridinin ortak sürücüsü.

  Sunucu (Liquid) etkin dönemi 'now' ile seçip basar; bu dosya:
  1. Dönemi tarayıcı saatiyle YENİDEN seçer. Sayfa önbellekten bayat geldiyse
     ya da sayfa açıkken dönem değiştiyse metinleri/renkleri/linkleri günceller.
  2. Geri sayımları çalıştırır, sıfırlanınca bir sonraki döneme geçer.
  3. "Kodu kopyala" düğmeleri.
  4. Ürün sayfasındaki kayan şeritte data-lak-mq öğelerini dönem metniyle doldurur.

  Önizleme testi: ?lak=<dönem id> (ör. ?lak=bf) o dönemin başlangıcını taklit eder.
  Takvim: shop metafield la_kampanya.takvim2 (repo: kampanya/takvim.json).
*/
(function () {
  if (window.__lak) return;
  window.__lak = true;

  var veriEl = document.querySelector('[data-la-kampanya-veri]');
  if (!veriEl) return;
  var takvim;
  try { takvim = JSON.parse(veriEl.textContent); } catch (e) { return; }
  if (!takvim || !takvim.donemler) return;

  var donemler = takvim.donemler.map(function (d) {
    d._bas = Date.parse(d.bas);
    d._bit = Date.parse(d.bit);
    return d;
  });

  // Test kaydırması: ?lak=<id> ya da ?lak_simdi=<ISO>
  var kaydirma = 0;
  try {
    var q = new URLSearchParams(location.search);
    var testId = q.get('lak');
    var testAn = q.get('lak_simdi');
    var hedef = testAn ? Date.parse(testAn) : null;
    if (testId) {
      var td = donemler.filter(function (d) { return d.id === testId; })[0];
      if (td) hedef = td._bas + 60000;
    }
    if (hedef) kaydirma = hedef - Date.now();
  } catch (e) {}

  function simdi() { return Date.now() + kaydirma; }

  function etkin() {
    var t = simdi();
    for (var i = 0; i < donemler.length; i++) {
      if (t >= donemler[i]._bas && t < donemler[i]._bit) return donemler[i];
    }
    return null;
  }  // Diğer betikler (sepet önerileri) kampanya fiyatını göstersin diye
  window.laKampanyaEtkin = function () { return etkin(); };


  var paraBirimi = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var para;
  try {
    para = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: paraBirimi });
  } catch (e) {
    para = { format: function (n) { return '$' + n.toFixed(2); } };
  }

  function indirimLinki(d, yol) {
    var hedef = yol || d.link;
    return d.kod ? '/discount/' + encodeURIComponent(d.kod) + '?redirect=' + encodeURIComponent(hedef) : hedef;
  }

  function goster(el, gorunur) {
    if (gorunur) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }

  var urunVeri = null;
  function urunVerisi() {
    if (urunVeri) return urunVeri;
    var el = document.querySelector('[data-lak-urun-veri]');
    try { urunVeri = el ? JSON.parse(el.textContent) : {}; } catch (e) { urunVeri = {}; }
    return urunVeri;
  }
  function kacis(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  // snippets/la-kampanya-hero-kart.liquid ile aynı işaretleme
  function sekmeKapali() { try { return sessionStorage.getItem('lak-sekme-kapali') === '1'; } catch (e) { return false; } }

  function kartlariCiz(kok, d) {
    var liste = kok.querySelector('[data-lak-kartlar]');
    var veri = urunVerisi();
    if (!liste || !d.urunler || !d.urunler.length) return;
    var html = '';
    d.urunler.slice(0, 3).forEach(function (h) {
      var u = veri[h];
      if (!u) return;
      var f = u.p, yeni = d.oran ? f - Math.round(f * d.oran / 100) : 0, fiyat;
      if (d.tur === 'satis' && yeni > 0) fiyat = '<s>' + para.format(f / 100) + '</s> <strong>' + para.format(yeni / 100) + '</strong><em>with ' + kacis(d.kod) + '</em>';
      else if (d.tur === 'erken' && yeni > 0) fiyat = '<s>' + para.format(f / 100) + '</s> <strong>' + para.format(yeni / 100) + '</strong><em>subscribers</em>';
      else fiyat = '<strong>' + para.format(f / 100) + '</strong>';
      html += '<li class="lak-kart"><a href="' + kacis(u.u) + '"><span class="lak-kart__gorsel">' +
        (u.i ? '<img src="' + kacis(u.i) + '" alt="' + kacis(u.t) + '" loading="lazy" width="400" height="400">' : '') +
        '</span><span class="lak-kart__ad">' + kacis(u.t) + '</span><span class="lak-kart__fiyat">' + fiyat + '</span></a></li>';
    });
    if (html) liste.innerHTML = html;
  }

  function doldur(kok, d) {
    var tur = kok.getAttribute('data-lak');

    if (!d) {
      // Kampanya bitti: bar, şerit, kart satırı, pencere, sekme kaybolur; slayt YEDEK içeriğe döner
      if (tur === 'bar' || tur === 'urun' || tur === 'kart' || tur === 'popup' || tur === 'sekme') goster(kok, false);
      if (tur === 'slayt') {
        var y = null;
        try { y = JSON.parse(kok.getAttribute('data-lak-yedek') || 'null'); } catch (e) {}
        if (y) {
          ['rozet', 'baslik', 'alt', 'cta'].forEach(function (a) { var el = kok.querySelector('[data-lak-f="' + a + '"]'); if (el && y[a]) el.textContent = y[a]; });
          kok.querySelectorAll('[data-lak-href]').forEach(function (el) { el.setAttribute('href', y.link || '/collections/all'); });
          if (y.bg) kok.style.setProperty('--lak-bg', y.bg);
          if (y.fg) kok.style.setProperty('--lak-fg', y.fg);
          kok.style.setProperty('--lak-vurgu', '#fe9f15');
          kartlariCiz(kok, { tur: 'yedek', urunler: y.urunler || [] });
          kok.classList.add('lak-hero--yedek');
        }
      }
      kok.querySelectorAll('[data-lak-sayac], [data-lak-goster]').forEach(function (el) {
        var liste = (el.getAttribute('data-lak-goster') || '').split(' ');
        goster(el, liste.indexOf('yedek') > -1);
      });
      kok.setAttribute('data-lak-donem', '');
      return;
    }

    ['bg', 'fg', 'vurgu', 'chip'].forEach(function (k) {
      if (d.renk && d.renk[k]) kok.style.setProperty('--lak-' + k, d.renk[k]);
    });

    kok.querySelectorAll('[data-lak-f]').forEach(function (el) {
      var alan = el.getAttribute('data-lak-f');
      if (d[alan] !== undefined && d[alan] !== null) el.textContent = d[alan];
    });

    kok.querySelectorAll('[data-lak-href]').forEach(function (el) {
      el.setAttribute('href', indirimLinki(d));
    });

    kok.querySelectorAll('[data-lak-goster]').forEach(function (el) {
      var liste = el.getAttribute('data-lak-goster').split(' ');
      goster(el, liste.indexOf(d.tur) > -1);
    });

    kok.querySelectorAll('[data-lak-kod-kutu]').forEach(function (el) { goster(el, !!d.kod); });
    kok.querySelectorAll('[data-lak-sayac]').forEach(function (el) { goster(el, true); });

    if (tur === 'slayt') kartlariCiz(kok, d);

    if (tur === 'sekme') {
      goster(kok, !sekmeKapali());
      var et = kok.querySelector('[data-lak-f="sekme_etiket"]');
      if (et) et.textContent = d.tur === 'satis' ? d.oran + '% OFF' : (d.tur === 'erken' ? 'Early access' : 'Coming soon');
    }

    if (tur === 'kart') {
      // Koleksiyon/ürün listesi kartı: yalnız satış döneminde kodlu fiyat satırı
      goster(kok, d.tur === 'satis' && !!d.oran);
      var kf = parseInt(kok.getAttribute('data-lak-fiyat'), 10) || 0;
      var kyeni = kok.querySelector('[data-lak-yeni]');
      if (kyeni && d.oran) kyeni.textContent = para.format((kf - Math.round(kf * d.oran / 100)) / 100);
    }

    if (tur === 'urun') {
      goster(kok, d.tur === 'satis' || d.tur === 'erken');
      var fiyat = parseInt(kok.getAttribute('data-lak-fiyat'), 10) || 0;
      var yol = kok.getAttribute('data-lak-redirect');
      if (d.oran) {
        var yeni = fiyat - Math.round(fiyat * d.oran / 100);
        var eski = kok.querySelector('[data-lak-eski]');
        var yeniEl = kok.querySelector('[data-lak-yeni]');
        if (eski) eski.textContent = para.format(fiyat / 100);
        if (yeniEl) yeniEl.textContent = para.format(yeni / 100);
      }
      var uygula = kok.querySelector('[data-lak-uygula]');
      if (uygula && d.kod) uygula.setAttribute('href', indirimLinki(d, yol));
    } else if (tur === 'bar') {
      goster(kok, true);
    }

    kok.setAttribute('data-lak-donem', d.id);
    kok.setAttribute('data-lak-tur', d.tur);
  }

  var sonId = null;
  function esitle(zorla) {
    var d = etkin();
    var id = d ? d.id : '';
    if (!zorla && id === sonId) return d;
    sonId = id;
    document.querySelectorAll('[data-lak]').forEach(function (kok) {
      if (zorla || kok.getAttribute('data-lak-donem') !== id) doldur(kok, d);
    });
    document.querySelectorAll('[data-lak-mq]').forEach(function (el) {
      if (!el.hasAttribute('data-lak-mq-yedek')) el.setAttribute('data-lak-mq-yedek', el.textContent);
      var alan = el.getAttribute('data-lak-mq');
      var metin = null;
      if (d && alan === 'mq' && d.mq) metin = d.mq;
      if (d && alan === 'kod' && d.kod) metin = '\u2705 USE CODE: ' + d.kod;
      el.textContent = metin || el.getAttribute('data-lak-mq-yedek');
    });
    document.documentElement.classList.toggle('lak-etkin', !!d);
    if (!d && barYazdi) {
      document.documentElement.style.removeProperty('--announcement-bar-height');
      barYazdi = false;
      // Temanın duyuru barı yeniden görünür oldu: yüksekliğini tema hesaplasın
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('theme:resize:width', { bubbles: true }));
    }
    barYuksekligiSonra();
    return d;
  }

  function etiket(d) {
    if (d.tur === 'satis') return 'Ends in';
    if (d.tur === 'teaser') return 'Starts in';
    if (d.id === 'bf-yakinda') return 'Opens in';
    return 'Black Friday in';
  }

  function iki(n) { return (n < 10 ? '0' : '') + n; }

  function sayaclar(d) {
    var els = document.querySelectorAll('[data-lak-sayac]');
    if (!d) return;
    var kalan = Math.max(0, d._bit - simdi());
    var s = Math.floor(kalan / 1000);
    var g = Math.floor(s / 86400); s -= g * 86400;
    var sa = Math.floor(s / 3600); s -= sa * 3600;
    var dk = Math.floor(s / 60); s -= dk * 60;
    els.forEach(function (el) {
      if (el.classList.contains('lak-sayac--kutu')) {
        el.innerHTML =
          '<span class="lak-sayac__etiket">' + etiket(d) + '</span>' +
          '<span class="lak-sayac__kutular">' +
          '<span><b>' + g + '</b><i>days</i></span>' +
          '<span><b>' + iki(sa) + '</b><i>hrs</i></span>' +
          '<span><b>' + iki(dk) + '</b><i>min</i></span>' +
          '<span><b>' + iki(s) + '</b><i>sec</i></span></span>';
      } else {
        el.textContent = etiket(d) + ' ' + (g ? g + 'd ' : '') + iki(sa) + 'h ' + iki(dk) + 'm ' + iki(s) + 's';
      }
    });
  }

  function kopyala(btn) {
    var kodEl = btn.querySelector('[data-lak-f="kod"], [data-lak-f="erken_kod"]');
    var kod = kodEl ? kodEl.textContent.trim() : '';
    if (!kod) return;
    var durum = btn.querySelector('[data-lak-kopya-durum]');
    function bitti() {
      btn.classList.add('lak-kod--kopyalandi');
      if (durum) durum.textContent = 'Copied!';
      setTimeout(function () {
        btn.classList.remove('lak-kod--kopyalandi');
        if (durum) durum.textContent = 'Tap to copy';
      }, 1800);
    }
    // Pano API'si reddederse (izin, http, eski tarayıcı) eski yönteme düş;
    // o da olmazsa "Copied!" deme, kodu seçili bırak ki elle kopyalansın.
    function eskiYontem() {
      var ta = document.createElement('textarea');
      ta.value = kod; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      if (ok) { bitti(); return; }
      if (kodEl && window.getSelection) {
        var r = document.createRange(); r.selectNodeContents(kodEl);
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      }
      if (durum) durum.textContent = 'Select & copy';
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(kod).then(bitti, eskiYontem);
    } else {
      eskiYontem();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lak-kopyala]');
    if (btn) { e.preventDefault(); kopyala(btn); }
  });

  /*
    Slider otomatik döndüğü için "Get early access" linkiyle gelen ya da formu
    dolduran ziyaretçi kampanya slaytından kaydırılmasın: temanın kendi
    'theme:slideshow:selectSlide' olayıyla o slayt seçilir ve autoplay durur.
  */
  function kampanyaSlaydiniTut() {
    var s = document.querySelector('.lak-slayt');
    var gosterici = s && s.closest('slideshow-element');
    if (!gosterici) return;
    var i = Array.prototype.indexOf.call(gosterici.querySelectorAll('[data-slide]'), s);
    if (i < 0) return;
    gosterici.dispatchEvent(new CustomEvent('theme:slideshow:selectSlide', { detail: { index: i } }));
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#la-kampanya"]');
    if (a && document.querySelector('.lak-slayt')) setTimeout(kampanyaSlaydiniTut, 0);
  });
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('.lak-slayt')) kampanyaSlaydiniTut();
  });

  /*
    Varyant değişimi: tema (product-info.js) yeni varyantın id'sini formdaki
    input[name="id"]'ye yazıp 'change' olayı gönderir. Fiyatı farklı varyantlı
    ürünlerde (9 Eki'de 40 ürün) şeritteki indirimli fiyat bununla güncellenir.
  */
  var varyantFiyatlari = {};
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'id' || !input.value || input.type !== 'hidden') return;
    // Yalnız temanın ana ürün formu (product-form-<bölüm>). "Frequently bought
    // together" gibi uygulamaların kendi name="id" seçim kutuları sayılmaz.
    var form = input.form || input.closest('form');
    if (!form || !/^product-form-/.test(form.id) || /installment/.test(form.id)) return;
    var kapsam = input.closest('product-info') || document;
    var kok = kapsam.querySelector('[data-lak="urun"]');
    if (!kok) return;
    var yol = kok.getAttribute('data-lak-redirect');
    var id = input.value;
    function uygula(fiyatlar) {
      if (fiyatlar[id] === undefined) return;
      kok.setAttribute('data-lak-fiyat', fiyatlar[id]);
      doldur(kok, etkin());
    }
    if (varyantFiyatlari[yol]) { uygula(varyantFiyatlari[yol]); return; }
    fetch(yol + '.js').then(function (r) { return r.json(); }).then(function (u) {
      var f = {};
      (u.variants || []).forEach(function (v) { f[String(v.id)] = v.price; });
      varyantFiyatlari[yol] = f;
      uygula(f);
    }).catch(function () {});
  });

  /*
    Sepette indirim: /discount/KOD linki kodu yalnız ödeme sayfasına taşır, sepet
    indirimsiz görünür. Satış dönemindeyse ve sepette başka kod yoksa kodu sepet
    API'siyle (cart/update.js discount) uygularız; tema sepette "50SCHOOL −$29.50"
    satırını kendisi basar. Oturum başına bir kez: müşteri kaldırırsa geri koymayız.
  */
  var sepetMesgul = false;
  function sepeteKodUygula() {
    var d = etkin();
    if (!d || d.tur !== 'satis' || !d.kod || sepetMesgul) return;
    var anahtar = 'lak-sepet-' + d.kod;
    try { if (sessionStorage.getItem(anahtar)) return; } catch (e) {}
    sepetMesgul = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c.item_count || (c.discount_codes && c.discount_codes.length)) return null;
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: d.kod })
      }).then(function (r) { return r.json(); }).then(function (c2) {
        var ok = (c2.discount_codes || []).some(function (x) { return x.code.toUpperCase() === d.kod.toUpperCase() && x.applicable; });
        try { sessionStorage.setItem(anahtar, ok ? '1' : 'uygulanamadi'); } catch (e) {}
        if (ok) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      });
    }).catch(function () {}).then(function () { sepetMesgul = false; });
  }
  ['theme:cart:add', 'theme:cart:change'].forEach(function (ad) {
    document.addEventListener(ad, function () { setTimeout(sepeteKodUygula, 400); });
  });

  /*
    Kampanya penceresi (sections/la-kampanya-popup.liquid). Satış döneminde kod,
    erken erişimde e-posta formu. 10 sn sonra ya da sayfadan çıkarken açılır;
    her dönemde ziyaretçiye bir kez (anahtar dönem id'si). Anasayfada açılmaz.
    Kayıt sonrası (customer_posted) kodla birlikte açık gelir.
  */
  function sekmeKur() {
    var s = document.querySelector('[data-lak="sekme"]');
    if (!s) return;
    var kart = s.querySelector('.lak-sekme__kart'), ac = s.querySelector('[data-lak-sekme-ac]');
    if (sekmeKapali()) s.hidden = true;
    ac.addEventListener('click', function () {
      var acik = kart.hidden;
      kart.hidden = !acik; ac.setAttribute('aria-expanded', String(acik));
      s.classList.toggle('lak-sekme--acik', acik);
    });
    s.querySelector('[data-lak-sekme-kapat]').addEventListener('click', function () {
      s.hidden = true;
      try { sessionStorage.setItem('lak-sekme-kapali', '1'); } catch (e) {}
    });
    // Ürün sayfasında tema altta sabit "sepete ekle" çubuğu (.shop-bar) açıyor;
    // görünürken sekmeyi onun üstüne kaldır.
    var cubuk = document.querySelector('.shop-bar');
    if (cubuk) {
      var bekliyor = false;
      var yerlestir = function () {
        bekliyor = false;
        var r = cubuk.getBoundingClientRect();
        var gorunur = r.height > 0 && r.top < window.innerHeight && getComputedStyle(cubuk).visibility !== 'hidden';
        s.style.bottom = gorunur ? (window.innerHeight - r.top + 12) + 'px' : '';
      };
      var tetikle = function () { if (!bekliyor) { bekliyor = true; requestAnimationFrame(yerlestir); } };
      window.addEventListener('scroll', tetikle, { passive: true });
      window.addEventListener('resize', tetikle);
      setInterval(tetikle, 1500); // çubuk sınıf değiştirerek açılıp kapanabiliyor
      tetikle();
    }

    var popAc = s.querySelector('[data-lak-popup-ac]');
    if (popAc) popAc.addEventListener('click', function () {
      var pop = document.querySelector('[data-lak="popup"]');
      kart.hidden = true; s.classList.remove('lak-sekme--acik');
      if (pop) pop.classList.add('lak-popup--acik');
    });
  }

  function popupKur() {
    var pop = document.querySelector('[data-lak="popup"]');
    if (!pop) return;
    var anahtar = function () { var d = etkin(); return 'lak-popup-' + (d ? d.id : ''); };
    var kapat = function () {
      pop.classList.remove('lak-popup--acik');
      try { localStorage.setItem(anahtar(), String(Date.now())); } catch (e) {}
    };
    pop.querySelectorAll('[data-lak-popup-kapat]').forEach(function (b) { b.addEventListener('click', kapat); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('lak-popup--acik')) kapat(); });
    var anasayfa = !!document.querySelector('.lak-slayt');
    if (pop.hasAttribute('data-lak-popup-gonderildi')) {
      // Kayıt anasayfadaki slayt formundan geldiyse kod zaten slaytta görünüyor
      if (!anasayfa) pop.classList.add('lak-popup--acik');
      return;
    }
    if (anasayfa) return;
    // Sepet sayfasında açma: müşteri zaten satın alıyor, kod sepete kendiliğinden uygulanıyor
    if (/^\/cart/.test(location.pathname)) return;
    var ac = function () {
      var d = etkin();
      if (!d || (d.tur !== 'satis' && d.tur !== 'erken') || pop.classList.contains('lak-popup--acik')) return;
      try { if (localStorage.getItem(anahtar())) return; } catch (e) {}
      // Sepet çekmecesi / menü / başka pencere açıkken araya girme (tema sayfayı kilitler)
      if (document.querySelector('[data-scroll-lock-locked="true"]') || document.documentElement.getAttribute('data-scroll-lock-locked') === 'true') {
        setTimeout(ac, 15000);
        return;
      }
      pop.classList.add('lak-popup--acik');
    };
    // Blog yazısında okuyucuyu 10. saniyede kesme: yazının yarısı geçilince ya da çıkarken aç
    if (document.body.classList.contains('template-article')) {
      var yarim = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.5) { window.removeEventListener('scroll', yarim); ac(); }
      };
      window.addEventListener('scroll', yarim, { passive: true });
    } else {
      setTimeout(ac, 10000);
    }
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) ac(); });
  }

  function tik() {
    var d = esitle(false);
    sayaclar(d);
  }

  /*
    Temanın sabit header'ı duyuru barının yüksekliğini --announcement-bar-height
    değişkeninden okur (announcement.js yazar). Duyuru barı gizliyken o değer 0
    olur ve header kampanya barının üstüne biner; bu yüzden değeri bar görünürken
    biz yazarız. announcement.js yeniden boyutlanmada 0 yazdığı için bir tık sonra
    tekrar yazılır.
  */
  var barYazdi = false; // değişkeni BİZ yazdıysak silebiliriz; temanın duyuru barının yazdığına dokunma
  function barYuksekligi() {
    var bar = document.querySelector('.lak-bar');
    if (!bar || bar.hidden) return;
    document.documentElement.style.setProperty('--announcement-bar-height', bar.offsetHeight + 'px');
    barYazdi = true;
  }
  function barYuksekligiSonra() { setTimeout(barYuksekligi, 60); }

  function basla() {
    if (document.querySelector('.lak-bar:not([hidden])')) barYazdi = true;
    esitle(true);
    barYuksekligi();
    sepeteKodUygula();
    popupKur();
    sekmeKur();
    window.addEventListener('load', barYuksekligiSonra);
    document.addEventListener('theme:resize:width', barYuksekligiSonra);
    window.addEventListener('resize', barYuksekligiSonra);
    if (window.ResizeObserver) {
      var barEl = document.querySelector('.lak-bar');
      if (barEl) new ResizeObserver(barYuksekligi).observe(barEl);
    }
    sayaclar(etkin());
    setInterval(tik, 1000);
    if (location.hash === '#la-kampanya' || /customer_posted=true/.test(location.search)) {
      // Slider kendini kurduktan sonra
      setTimeout(kampanyaSlaydiniTut, 400);
      window.addEventListener('load', function () { setTimeout(kampanyaSlaydiniTut, 100); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
